export { default } from "./NotifyBox-component";
